export enum MapPickerMode {
	NONE = 'NONE',
	ORIGIN = 'ORIGIN',
	DESTINATION = 'DESTINATION',
}
